import './UiDataGrid.scss';
import { createDataRow, createHeaderCell } from '../DataGridCustom.Helpers';
import ColumnDefinition from '../../../../infrastructure/types/DataGrid/ColumnDefinition';
import React from 'react';

interface UiDataGridProps<T> {
    columns: ColumnDefinition<T>[];
    data: T[];
    getKey: (record: T, i: number) => string | number;
    tableClassName?: string;
}

class UiDataGridCustom<T> extends React.Component<UiDataGridProps<T>> {

    constructor(props: UiDataGridProps<T>) {
        super(props);

        this.getNoItemsContent = this.getNoItemsContent.bind(this);
    }

    getNoItemsContent(): JSX.Element {

        if (this.props.data.length > 0) {
            return <></>;
        }

        return (
            <div>
                <div className="no-items-text">No items</div>
            </div>
        );
    }

    render(): JSX.Element {
        return (
            <div className="width-100-percents">
                <div className={`${this.props.tableClassName || '.table ui-data-grid grid'}`}>
                    <div className='thead sticky'>
                        <div className='display-flex tr'>
                            {this.props.columns.map((c, i) => createHeaderCell(c, i, null as any))}
                        </div>
                    </div>
                    <div>
                        {this.getNoItemsContent()}
                        {this.props.data.map((item, i) => createDataRow(this.props.columns, item, i, this.props.getKey))}
                    </div>
                </div>
            </div>
        );
    }
}

export default UiDataGridCustom;
